const module = { name: 'mobile/search.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { default as search } from 'swug-fdRequire-call:mobile/search';



import { Fandango_debugLog as debugLog } from 'require-core';

function init() {
    checkDependencies(module.name, debugLog);
    search.init();
}
document.addEventListener('DOMContentLoaded', init);
export default module.exports;